import { useEffect, useState, useCallback } from "react";
import { Header } from "@/components/Header";
import { DailyLogCard } from "@/components/DailyLogCard";
import { WeeklyView } from "@/components/WeeklyView";
import { MonthlyView } from "@/components/MonthlyView";
import { AnnualView } from "@/components/AnnualView";
import { api } from "@/lib/api";
import { estToday } from "@/lib/grades";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

export default function PatientDashboard() {
  const [todayEntry, setTodayEntry] = useState(undefined);
  const today = estToday();

  const loadToday = useCallback(() => {
    api
      .get("/entries", { params: { start: today, end: today } })
      .then((r) => setTodayEntry(r.data[0] || null))
      .catch(() => setTodayEntry(null));
  }, [today]);

  useEffect(() => {
    loadToday();
  }, [loadToday]);

  return (
    <div className="min-h-screen">
      <Header />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <Tabs defaultValue="today" className="w-full">
          <TabsList className="rounded-full bg-secondary p-1 mb-8">
            <TabsTrigger value="today" data-testid="view-tab-today" className="rounded-full px-5">Today</TabsTrigger>
            <TabsTrigger value="weekly" data-testid="view-tab-weekly" className="rounded-full px-5">Weekly</TabsTrigger>
            <TabsTrigger value="monthly" data-testid="view-tab-monthly" className="rounded-full px-5">Monthly</TabsTrigger>
            <TabsTrigger value="annual" data-testid="view-tab-annual" className="rounded-full px-5">Annual</TabsTrigger>
          </TabsList>

          <TabsContent value="today">
            {todayEntry !== undefined && <DailyLogCard existing={todayEntry} onSaved={loadToday} />}
          </TabsContent>
          <TabsContent value="weekly"><WeeklyView patientId={null} /></TabsContent>
          <TabsContent value="monthly"><MonthlyView patientId={null} /></TabsContent>
          <TabsContent value="annual"><AnnualView patientId={null} /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
